import React from "react";
import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NeonDivider } from "@/components/NeonDivider";
import { NAV_LINKS, SERVICES } from "@/lib/data";

export const Footer = () => {
  const year = new Date().getFullYear();
  const routeFor = (id) => (id === "home" ? "/" : `/${id}`);

  const socials = [
    { icon: Linkedin, label: "LinkedIn", href: "#" },
    { icon: Twitter, label: "Twitter", href: "#" },
    { icon: Github, label: "GitHub", href: "#" },
    { icon: Mail, label: "Email", href: "mailto:hello@metistechlabs.com" },
  ];

  return (
    <footer className="relative z-10 mt-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <NeonDivider />
        <div className="glass-strong mt-0 rounded-b-none rounded-t-2xl border-t-0 px-6 py-12 sm:px-10">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
            <div className="md:col-span-1">
              <Logo />
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-brand">
                Engineering AI-powered software, automations, and business systems for serious companies.
              </p>
            </div>

            <div>
              <h4 className="mb-4 text-xs uppercase tracking-[0.18em] text-white">Quick Links</h4>
              <ul className="space-y-2.5">
                {NAV_LINKS.map((l) => (
                  <li key={l.id}>
                    <Link
                      to={routeFor(l.id)}
                      className="text-sm text-muted-brand transition-colors hover:text-neon-g"
                      data-testid={`footer-link-${l.id}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="mb-4 text-xs uppercase tracking-[0.18em] text-white">Services</h4>
              <ul className="space-y-2.5">
                {SERVICES.slice(0, 6).map((s) => (
                  <li key={s.id}>
                    <Link to="/services" className="text-sm text-muted-brand transition-colors hover:text-neon-g">
                      {s.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="mb-4 text-xs uppercase tracking-[0.18em] text-white">Connect</h4>
              <div className="flex gap-3">
                {socials.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    className="flex h-10 w-10 items-center justify-center rounded-full glass text-muted-brand transition-all duration-300 hover:text-neon-g hover:shadow-[var(--glow-g)]"
                  >
                    <s.icon size={17} />
                  </a>
                ))}
              </div>
              <p className="mt-5 text-sm text-muted-brand">hello@metistechlabs.com</p>
              <p className="text-sm text-muted-brand">+1 (415) 555-0142</p>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[rgba(255,255,255,0.06)] pt-6 text-xs text-muted-brand sm:flex-row">
            <p>© {year} Métis Tech Labs. All rights reserved.</p>
            <p className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--neon-g)] shadow-[0_0_8px_var(--neon-g)]" />
              Systems operational
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
